import { render, staticRenderFns } from "./v-map.vue?vue&type=template&id=372daae6&"
import script from "./v-map.vue?vue&type=script&lang=js&"
export * from "./v-map.vue?vue&type=script&lang=js&"
import style0 from "./v-map.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports